import { getStoredTeacherId } from "../context/AuthContext";
import { getTelemetryConfig } from "./telemetryConfig";
import { getTelemetrySessionId } from "./telemetrySession";

let contextResolver = () => ({});

export function setTelemetryContextResolver(resolver) {
  contextResolver = typeof resolver === "function" ? resolver : () => ({});
}

export function buildTelemetryContext(overrides = {}) {
  const config = getTelemetryConfig();

  return {
    moduleId: config.moduleId,
    environment: config.environment,
    sessionId: getTelemetrySessionId(),
    teacherId: getStoredTeacherId(),
    role: config.defaultRole,
    ...contextResolver(),
    ...overrides,
  };
}
